import React, { useState, useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form';
import AlertContext from '../../../GlobalComponents/Alert/contexts/alertContext';
//import global components
import { Modal, SideBar, Table } from '../../../../imports';

//import icons from heroicons
import { PlusCircleIcon, ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useLoader } from '../../../../context/LoaderContext.';
import { AgregarProyectoEmpresa, EditarProyectoEmpresa, EliminarProyectoEmpresa, ObtenerEtapasProyecto, ObtenerProyectosEmpresa } from '../../../../servicios/ServicioProyectoEmpresa';
import { AddProjectComponent } from './AddProjectComponent';

export default function Proyectos() {


    //list to save and send data to table
    const [listProyectos, setListProyectos] = useState([]);
    const [etapasProyecto, setEtapasProyecto] = useState([]);

    const [listUserTechnologies, setListUserTechnologies] = useState([]);

    //use alert context
    const alertCtx = useContext(AlertContext);

    //use modal and show for add
    const [showAddModal, setShowAddModal] = useState(false);

    //use modal and show for edit
    const [showEditModal, setShowEditModal] = useState(false);

    //use modal and show for delete
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    //use to get id with set options when click events
    const [idFromEdit, setIdFromEdit] = useState(null);
    const [idFromDeactivate, setIdFromDeactivate] = useState(0);
    const { showLoader, hideLoader } = useLoader();

    //use to get state from colums
    const [stateTech, setStateTech] = useState(null);

    //get current user id
    const jsonUsuario = sessionStorage.getItem("USER_DATA");
    const usuario = JSON.parse(jsonUsuario);


    //declare register to form
    //use react hook form to get values and make validations
    const { register, getValues, setValue, handleSubmit, formState: { errors } } = useForm({
        mode: 'all',
        defaultValues: {
            techName: ''
        }
    });

    async function getProyectos() {

        showLoader();
        const response = await ObtenerProyectosEmpresa();
        hideLoader();
        setListProyectos(response);

    }

    async function getEtapas() {
        const response = await ObtenerEtapasProyecto();
        if (response !== undefined) {
            console.log(response)
            setEtapasProyecto(response);
        }

    }

    async function EditTech(id, proyecto) {
        const tecnologiasFormato = listUserTechnologies.map(({ id, ...rest }) => ({
            idTecnologia: Number(id),  // Asignamos id a idTecnologia
        }));
        const data = {
            IdProyecto: id,
            Nombre: proyecto.nombre,
            Descripcion: proyecto.descripcion,
            Tecnologias: tecnologiasFormato,
            Etapa: Number(proyecto.etapaProyecto),
            UsuarioModificacion: String(usuario.Correo),
        }
        console.log(data)

        showLoader();
        const response = await EditarProyectoEmpresa(data);
        hideLoader();

        if (response.indicador === 0) {
            alertCtx.success(response.mensaje);
        } else {
            alertCtx.error(response.mensaje);
        }
    }

    async function AddTechnologie(proyecto) {
        const tecnologiasFormato = listUserTechnologies.map(({ id, ...rest }) => ({
            idTecnologia: Number(id),  // Asignamos id a idTecnologia
        }));
        const data = {
            Nombre: proyecto.nombre,
            Descripcion: proyecto.descripcion,
            Tecnologias: tecnologiasFormato,
            Etapa: Number(proyecto.etapaProyecto),
            UsuarioCreacion: String(usuario.Correo),
        }

        showLoader();
        const response = await AgregarProyectoEmpresa(data);
        hideLoader();

        if (response.indicador === 0) {
            alertCtx.success(response.mensaje);
        } else {
            alertCtx.error(response.mensaje);
        }
    }

    async function DeactivateTech(id, estado) {

        showLoader();
        const response = await EliminarProyectoEmpresa(id);
        hideLoader();

        if (response.indicador === 0) {
            alertCtx.success(response.mensaje);
        } else {
            alertCtx.error(response.mensaje);
        }
    }

    const accionEditarProyecto = (row) => {
        setShowEditModal(true);
        let transformedArray = [];
        if (row.tecnologiasJSON !== null) {
            const listaTecnologias = JSON.parse(row.tecnologiasJSON)
            transformedArray = listaTecnologias?.map(item => ({
                id: item.idtecnologia,
                checked: true
            }));
        }
        setIdFromEdit(row?.idProyecto);
        setValue("nombreProyectoE", row?.nombre);
        setValue("descripcionE", row?.descripcion);
        setValue("etapaE", row?.idEtapa);
        console.log(row)
        setListUserTechnologies(transformedArray)

    }

    const accionAgregarProyecto = () => {
        setShowAddModal(!showAddModal);
        setValue("nombreProyecto", "");
        setValue("descripcion", ""),
            setValue("etapaProyecto", parseInt(1, 10));
        setListUserTechnologies([]);
        
    }

    const cambiarEstadoVacante = (row) => {
        setStateTech(row?.estado);
        setIdFromDeactivate(row?.idProyecto);
        setShowDeleteModal(true);
    }

    //**change this colums with entities names or need data**op
    const columns = [
        {
            name: 'Nombre',
            selector: row => row?.nombre,

        },
        {
            name: 'Descripción',
            selector: row => row?.descripcion,
        },
        {
            name: 'Estado',
            selector: row => row?.estado ? "Activo" : "Inactivo",
        },
        {
            name: 'Etapa',
            selector: row => row?.descripcionEtapa
        },
        {
            name: 'Acciones',
            selector: row => row?.estado,
            cell: (row) =>
                <div>
                    <button type="button" id={row?.IdVacante} onClick={() => { accionEditarProyecto(row); }} className="rounded-full text-sm w-32 py-2 px-4 border-solid border-2 border-black-RS text-black-RS font-bold  m-2 hover:border-gray-200 ">Editar</button>
                    {row?.estado === true ? <button type="button" id={row?.idVacante} onClick={() => { setStateTech(row?.estado); setIdFromDeactivate(row?.idProyecto); setShowDeleteModal(true); }} className="rounded-full text-sm w-32 py-2 px-4 border-solid border-2 border-red-RS text-red-RS font-bold  m-2 hover:border-gray-200  " >Cerrar</button >
                        : <button type="button" id={row?.idVacante} onClick={() => { cambiarEstadoVacante(row) }} className="rounded-full text-sm w-32 py-2 px-4 border-solid border-2 border-greenButton text-greenButton font-bold  m-2 hover:border-gray-200" >Activar</button >}


                </div>
            ,
            width: "500px",
            ignoreRowClick: true,
            allowOverflow: true,
        },

    ]

    const onSaveEditOptions = () => {
        const nombreEmpresa = getValues("nombreProyectoE");
        const descripcion = getValues("descripcionE");
        const etapaProyecto = getValues("etapaE");


        const obj = { nombre: nombreEmpresa, descripcion, etapaProyecto }

        EditTech(idFromEdit, obj)

        setShowEditModal(false);

        setValue("nombreProyectoE", "");
        setValue("descripcionE", "");
        setValue("etapaE", "");

        const timeout = setTimeout(() => {
            getProyectos();
        }, 1000);
        return () => clearTimeout(timeout);
    }

    const onSaveDeleteOptions = () => {

        DeactivateTech(idFromDeactivate, !stateTech)

        setShowDeleteModal(false);
        const timeout = setTimeout(() => {
            getProyectos();
        }, 1000);
        return () => clearTimeout(timeout);
    }

    const onSaveAddOptions = () => {
        const nombreEmpresa = getValues("nombreProyecto");
        const descripcion = getValues("descripcion");
        const etapaProyecto = getValues("etapaProyecto");

        const obj = { nombre: nombreEmpresa, descripcion, etapaProyecto }

        AddTechnologie(obj);

        setShowAddModal(false);

        const timeout = setTimeout(() => {
            setValue("nombreProyecto", "");
            setValue("descripcion", "");
            setValue("etapaProyecto", "");
            setListUserTechnologies([])
            getProyectos();

        }, 1000);
        return () => clearTimeout(timeout);
    }

    useEffect(() => {
        const fetchData = async () => {
            showLoader();
            await getProyectos();
            await getEtapas();
            hideLoader();
        };
        fetchData();
    }, []);

    //use to show delete new role component when 'eliminar' button is activated
    const DeleteProjectComponent = () => {
        return (
            <form className="space-y-2 md:space-y-4">
                <div className="w-96 container mx-auto items-center justify-center">
                    <div className="flex flex-col">
                        <div className="flex text-base m-2 justify-center mx-auto font-bold leading-tight tracking-tight text-red-RS">
                            <ExclamationTriangleIcon className="w-8 h-8 ml-2"></ExclamationTriangleIcon>
                        </div>
                        <div>
                            <h1 className="flex text-base justify-center mx-auto font-bold leading-tight tracking-tight text-white">
                                Advertencia
                            </h1>
                        </div>

                        <div>
                            <label className="flex text-base justify-center mx-auto m-2 py-2 text-sm font-medium text-white">¿Está seguro que desea cambiar el estado de este elemento?</label>
                        </div>

                    </div>
                </div>
            </form>
        )
    }
    return (
        <>

            <div className="flex flex-row">
                <div className="md:basis-1/4 xl:basis-1/5 ">
                    <SideBar />
                </div>
                <div className="md:basis-3/4 xl:basis-11/12">
                    <div className="bg-white rounded-lg shadow-lg shadow-slate-400 px-2 py-2  mt-2 m-2 mr-8">

                        <div className="px-2">
                            <div className="absolute z-20 ml-4 mt-1">
                                <h1 className="left-0 text-xl font-bold text-black-RS mb-1">Catálogo Proyectos</h1>
                                <div className="col-start-1 col-end-3 ">
                                    <div className="items-center sm:flex">
                                        <button type="button" onClick={() => {
                                            accionAgregarProyecto();
                                        }} className="bg-greenButton hover:bg-primary-700 text-white text-sm  py-2 px-4 rounded inline-flex items-center">
                                            <span>Agregar</span>
                                            <PlusCircleIcon className="w-8 h-8 ml-2"></PlusCircleIcon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="static px-2 mt-2 m-2">
                                <Table columns={columns} title="vacantes" filteredItems={""} data={listProyectos} filterBy="descripcion" />
                            </div>
                        </div>
                        {/*Here we show add modal compononent*/}
                        <Modal insideContainer={{
                            className: 'w-full', // Usa w-full para ocupar todo el ancho permitido
                            style: { maxWidth: '1000px', padding: '24px' },
                        }} isVisible={showAddModal} onClose={() => { setShowAddModal(false) }} handleSubmit={handleSubmit} onSaveOptions={onSaveAddOptions} showCloseIcon={false} >
                            {/*Button to close modal*/}
                            <div className="flex justify-end m-2">
                                <button className="cursor-pointer text-black-400 hover:text-gray-600 transition duration-150 ease-in-out rounded ring-2 focus:outline-none ring-gray-600" onClick={() => setShowAddModal(false)} aria-label="close modal" role="button">
                                    <XMarkIcon className="text-red-RS h-6 w-6" />
                                </button>
                            </div>
                            <AddProjectComponent errors={errors} etapas={etapasProyecto} register={register} listUserTechnologies={listUserTechnologies} setListUserTechnologies={setListUserTechnologies} />
                        </Modal>

                        {/*Here we show edit modal compononent*/}
                        <Modal insideContainer={{
                            className: 'w-full', // Usa w-full para ocupar todo el ancho permitido
                            style: { maxWidth: '1000px', padding: '24px' },
                        }} isVisible={showEditModal} onClose={() => { setShowEditModal(false) }} handleSubmit={handleSubmit} onSaveOptions={onSaveEditOptions} showCloseIcon={false} >
                            {/*Button to close modal*/}
                            <div className="flex justify-end m-2">
                                <button className="cursor-pointer text-black-400 hover:text-gray-600 transition duration-150 ease-in-out rounded ring-2 focus:outline-none ring-gray-600" onClick={() => setShowEditModal(false)} aria-label="close modal" role="button">
                                    <XMarkIcon className="text-red-RS h-6 w-6" />
                                </button>
                            </div>
                            <AddProjectComponent etapas={etapasProyecto} fieldNames={{ nombreProyecto: "nombreProyectoE", descripcion: "descripcionE", etapaProyecto: "etapaE" }} errors={errors} register={register} listUserTechnologies={listUserTechnologies} setListUserTechnologies={setListUserTechnologies} />
                        </Modal>

                        {/*Here we show delete modal compononent*/}
                        <Modal isVisible={showDeleteModal} onClose={() => { setShowDeleteModal(false) }} handleSubmit={handleSubmit} onSaveOptions={onSaveDeleteOptions} showCloseIcon={false}>
                            {/*Button to close modal*/}
                            <div className="flex justify-end m-2">
                                <button className="cursor-pointer text-black-400 hover:text-gray-600 transition duration-150 ease-in-out rounded ring-2 focus:outline-none ring-gray-600" onClick={() => setShowDeleteModal(false)} aria-label="close modal" role="button">
                                    <XMarkIcon className="text-red-RS h-6 w-6" />
                                </button>
                            </div>
                            <DeleteProjectComponent />
                        </Modal>

                    </div>
                </div>

            </div>

        </>
    )
}
